import React from 'react';
import { BlockType } from '@tradingblock/types';
import { BlockDragHandle, getBlockTypeName } from '@tradingblock/components';
import { CashieringStatusIcon } from '../../../components/dashboard/CashieringStatusIcon';

interface HeaderProps {
  blockType: BlockType;
}

export const AdminCashieringHeader: React.FunctionComponent<HeaderProps> = ({ blockType }) => {
  return (
    <>
      <div className="block-nav nav">
        <BlockDragHandle className="nav-item">{getBlockTypeName(blockType)}</BlockDragHandle>
        <CashieringStatusIcon />
      </div>
    </>
  );
};
